import { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import qs from "qs";

export function useQueryParams() {
  const history = useHistory();
  const { search } = useLocation();

  const queryParams = useMemo(
    () =>
      qs.parse(search, {
        ignoreQueryPrefix: true,
      }),
    [search]
  );
  const setQueryParams = (params) => {
    history.push({
      search: qs.stringify(params, {
        addQueryPrefix: true,
        arrayFormat: "repeat",
      }),
      state: { ...history.location.state },
    });
  };
  return [queryParams, setQueryParams];
}
